import {
    AgeSegmentRoomState,
    BookingHotelImageState,
    BookingState,
} from '../../types/booking/BookingTypes';
import { ISupplierBooking } from '../../types/entities/ISupplierBooking';
import { OTA_REFERENCE_TABLE_CODE_KEY } from '../../utils/bookings/bookingUtils';

export const adaptDDBBBookingToState = (
    booking: ISupplierBooking
): BookingState => {
    const hotelImages: BookingHotelImageState[] =
        booking?.SupplierHotel?.SupplierHotelImages?.filter(
            img => img?.Published
        )
            .sort((a, b) =>
                a?.Feature === b?.Feature ? 0 : a?.Feature ? -1 : 1
            ) // 2️⃣ feature primero
            .slice(0, 4)
            .map(image => ({
                id: image?.Id || '',
                caption: image?.Caption || '',
                published: image?.Published || false,
                feature: image?.Feature || false,
                virtualPath: image?.VirtualPath || '',
            })) || [];

    while (hotelImages.length < 4) {
        hotelImages.push(null);
    }
    return {
        status:
            booking?.SupplierBookingStatus?.SupplierBookingStatusType
                ?.LocalizedCaption ||
            booking?.SupplierBookingStatus?.SupplierBookingStatusType
                ?.Caption ||
            booking?.SupplierBookingStatus?.SupplierBookingStatusType?.Name ||
            '',
        statusColor:
            booking?.SupplierBookingStatus?.SupplierBookingStatusType?.Color ||
            '',
        hotel: booking?.SupplierHotel?.Name || '',
        hotelImages,
        address: booking?.SupplierHotel?.Hotel?.Address || '',
        hotelRating:
            booking?.SupplierHotel?.Hotel?.HotelCategory?.RatingNumber || 0,
        hotelCategory:
            booking?.SupplierHotel?.Hotel?.HotelCategory?.LocalizedCaption ||
            booking?.SupplierHotel?.Hotel?.HotelCategory?.Caption ||
            booking?.SupplierHotel?.Hotel?.HotelCategory?.LocalizedCaption ||
            '',
        bookingCode: booking?.BookingCode || '',
        hotelRefecerenceCode:
            booking?.ReservationIDs?.find(
                item =>
                    item?.OTAReferenceTableCode?.Key ===
                    OTA_REFERENCE_TABLE_CODE_KEY
            )?.ResID_Value || '',
        checkIn: booking?.CheckInDate || null,
        checkOut: booking?.CheckOutDate || null,
        bookingDate: booking?.BookingDate || null,
        nights: booking?.Nights || 0,
        paxes: booking?.Paxes || 0,
        totalAmount: booking?.TotalAmount || 0,
        paymentId: parseInt(booking?.SupplierBookingPaymentInfo?.Id) || 0,
        currency: booking?.Currency?.Key || '',
        customerName: booking?.ZoeBooking?.EndCustomer?.FullName || '',
        notes: booking?.Remarks || '',

        cancellationPolicies:
            booking?.SupplierBookingCancellationPolicy?.DecodedPenalties.map(
                (pen, index) => ({ text: pen, id: index + 1 })
            ),
        rooms: booking?.Rooms?.map(room => ({
            id: room?.Id || '',
            roomType: room?.SupplierHotelRoomType?.Name || '',
            roomMappingCode: room?.SupplierHotelRoomType?.MappingCode || '',
            mealPlan: room?.SupplierHotelMealPlan?.Name || '',
            mealPlanMappingCode: room?.SupplierHotelMealPlan?.MappingCode || '',
            ratePlan: room?.SupplierHotelRatePlan?.Name || '',
            ratePlanMappingCode: room?.SupplierHotelRatePlan?.MappingCode || '',
            rates: room?.Rates?.map(rate => ({
                id: rate?.Id || '',
                amount: rate?.AmountAfterTax || 0,
            })),
            guests:
                room?.Paxes?.map(pax => ({
                    name: pax?.Name || '',
                    surname: pax?.Surname || '',
                    age: pax?.Age || 0,
                    ageSegment: pax.IsBaby
                        ? AgeSegmentRoomState.BABY
                        : pax?.IsChild
                        ? AgeSegmentRoomState.CHILD
                        : AgeSegmentRoomState.ADULT,
                })) || [],
        })),
        prices: booking?.Rooms?.map(room => ({
            id: room?.Id || '',
            room: room?.SupplierHotelRoomType?.Name || '',
            rates:
                room?.Rates?.map((rate, ind) => ({
                    id: rate?.Id || '',
                    amount: rate?.AmountAfterTax || 0,
                    night: ind + 1,
                })) || [],
        })),
    };
};
